import { createTheme } from '@mui/material/styles';
import { passportColors } from './passportTokens';

export function createPassportTheme(baseTheme) {
  return createTheme({
    ...baseTheme,
    // Passport surfaces are authored against MUI's default 8px unit (p: 3 === 24px).
    // The root theme uses a 16px rhythm, which the spread above would inherit and
    // double every gutter, collapsing nested card columns to a few pixels wide.
    spacing: 8,
    palette: {
      ...baseTheme.palette,
      mode: 'dark',
      background: {
        default: passportColors.background,
        paper: passportColors.surface,
      },
      text: {
        primary: passportColors.textPrimary,
        secondary: passportColors.textSecondary,
      },
      primary: {
        main: passportColors.focus,
      },
      secondary: {
        main: passportColors.warning,
      },
    },
    typography: {
      ...baseTheme.typography,
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      h1: {
        fontFamily: '"Noto Serif", serif',
        fontStyle: 'italic',
      },
      h2: {
        fontFamily: '"Noto Serif", serif',
        fontStyle: 'italic',
      },
      h3: {
        fontFamily: '"Space Grotesk", sans-serif',
      },
    },
  });
}
